import React, { useCallback, useState } from 'react';
import { useConfig } from '@lore/config';
import useHomepageVideos from '@/features/home-videos/api/useHomepageVideos';
import HomeVideosSection from './HomeVideosSection';
import HomeVideosSkeleton from './HomeVideosSkeleton';
import VideoDialog from './VideoDialog';

/**
 * Home-screen videos: fetches the home set, renders the section and owns the
 * video dialog. The server picks the set from the user's audience, so any
 * user sees the section when it returns videos. Renders nothing for zero
 * videos or a failed request.
 */
export default function HomeVideos() {
  const config = useConfig();
  const learningHubUrl = config.homeVideos?.learningHubUrl || null;
  const { data: videos, isLoading, isError } = useHomepageVideos();
  const [openVideo, setOpenVideo] = useState(null);

  const handleWatch = useCallback((video) => setOpenVideo(video), []);
  const handleClose = useCallback(() => setOpenVideo(null), []);

  if (isLoading) return <HomeVideosSkeleton />;
  if (isError || !videos || videos.length === 0) return null;

  return (
    <>
      <HomeVideosSection videos={videos} onWatch={handleWatch} learningHubUrl={learningHubUrl} />
      {openVideo && (
        <VideoDialog
          key={openVideo.id}
          initialVideo={openVideo}
          onClose={handleClose}
          learningHubUrl={learningHubUrl}
        />
      )}
    </>
  );
}
